import Loading from 'components/login/Loading';
import { logout } from 'actions/loginActions';

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { hashHistory } from 'react-router';
import PropTypes from 'prop-types';


class LoadingContainer extends React.Component {

  /* React lifecycle functions */
  componentDidMount() {
    const searchParams = window.location.search && window.location.search.split('&');
    if (searchParams && searchParams[0].split('=')[1] === 'logout') {
      const countryCode = searchParams[1] && searchParams[1].split('=')[1];
      this.props.logout(countryCode);
    } else {
      hashHistory.push('/login');
    }
  }

  render() {
    return (
      <Loading />
    );
  }
}

LoadingContainer.propTypes = {
  // User accesses page with page query param set to 'logout'
  logout: PropTypes.func.isRequired
};

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({
      logout
    }, dispatch)
  };
}

export default connect(null, mapDispatchToProps)(LoadingContainer);
